import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <form class="groups-form form-vertical">
  <GroupsFormProfileFields @model={{this.model}} @disableSave={{this.saving}} />
  <GroupManageSaveButton @model={{this.model}} @saving={{this.saving}} />
</form>
*/
{
  "id": "0wrlwvoi",
  "block": "[[[10,\"form\"],[14,0,\"groups-form form-vertical\"],[12],[1,\"\\n  \"],[8,[39,0],null,[[\"@model\",\"@disableSave\"],[[30,0,[\"model\"]],[30,0,[\"saving\"]]]],null],[1,\"\\n  \"],[8,[39,1],null,[[\"@model\",\"@saving\"],[[30,0,[\"model\"]],[30,0,[\"saving\"]]]],null],[1,\"\\n\"],[13]],[],false,[\"groups-form-profile-fields\",\"group-manage-save-button\"]]",
  "moduleName": "discourse/templates/group/manage/profile.hbs",
  "isStrictMode": false
});